import { render, staticRenderFns } from "./SickKindSelectPage.vue?vue&type=template&id=32a96e8e&scoped=true"
import script from "./SickKindSelectPage.vue?vue&type=script&lang=js"
export * from "./SickKindSelectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a96e8e",
  null
  
)

export default component.exports